import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { BrowserRouter } from 'react-router-dom';

// Set API base URL from environment variable
const API_URL = process.env.REACT_APP_API_URL || 'https://api.edx.red';

// Error logging
window.addEventListener('error', function(event) {
  console.error('Global error caught:', event.error);
  // Display error on page
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: sans-serif;">
      <h1>Something went wrong</h1>
      <pre style="background: #f5f5f5; padding: 15px; border-radius: 4px; overflow: auto;">
        ${event.error?.stack || event.message || 'Unknown error'}
      </pre>
    </div>
  `;
});

// Create the root element
const root = ReactDOM.createRoot(document.getElementById('root'));

// Add this before root.render
console.log('Starting React render');

try {
  root.render(
    <React.StrictMode>
      {console.log('Rendering StrictMode')}
      <AuthProvider>
        {console.log('Rendering AuthProvider')}
        <ThemeProvider>
          {console.log('Rendering ThemeProvider')}
          <BrowserRouter>
            {console.log('Rendering BrowserRouter')}
            <App apiUrl={API_URL} />
          </BrowserRouter>
        </ThemeProvider>
      </AuthProvider>
    </React.StrictMode>
  );
  console.log('React rendering initiated');
} catch (error) {
  console.error('Error during React rendering:', error);
  // Display visible error on page
  document.getElementById('root').innerHTML = `
    <div style="padding: 20px; font-family: sans-serif;">
      <h1>React Error</h1>
      <p>${error.message}</p>
      <pre>${error.stack}</pre>
    </div>
  `;
}

// If you want to enable performance measurements, uncomment the following:
// import reportWebVitals from './reportWebVitals';
// reportWebVitals(console.log);